import { Suspense } from 'react';
import './Modal.css';
import closeIcon from '../../assets/icons/close.png';

export default function Modal(props) {

  return (
        
        <div className={'transparent-div'} style={{backgroundColor: props.bg ?? 'rgb(0, 0, 0, .1)'}}>

            <div className={'custom-card cardMain'} style={props.formName === '' ? {width:'16%'} : {...props.style}}>
                <div className={'cardHeader'}>
                    <p className={'formName'}>{props.formName}</p>
                    <img src={closeIcon} className={'close'} style={{width:7, height:7, transform:'scale(3.5)'}} onClick={props.close}/>
                </div>
                <div className={'cardBody'}>
                    <Suspense fallback={<p style={{textAlign:'center'}}>Loading...</p>}>
                        {props.children}
                    </Suspense>
                </div>
                
            </div>
    
        </div> 
  )
}
